export enum DateTypeModel {
    CURRENT_PERIOD = 'current_period',
    PREVIOUS_PERIOD = 'previous_period',
    PERIODS = 'periods',
    PERIODS_WEEK = 'periods_week',
    THIS_YEAR = 'this_year',
    THIS_MONTH = 'this_month',
    LATEST_BUSINESS_DAY = 'latest_business_date',
    SINGLE = 'single',
    CUSTOM = 'custom'
}
